import { render, staticRenderFns } from "./expertResponseDetailsModal.vue?vue&type=template&id=60df4abd&scoped=true&"
import script from "./expertResponseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./expertResponseDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./expertResponseDetailsModal.vue?vue&type=style&index=0&id=60df4abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df4abd",
  null
  
)

export default component.exports